import { useState } from "react";
import { FadeUp } from "./Reveal";

const fmt = (n) => `$${Math.round(n).toLocaleString("en-AU")}`;
const PRESETS = [2500, 7000, 15000];

export default function SpendCalculator() {
  const [paid, setPaid] = useState(7000);

  return (
    <FadeUp delay={0.15} className="mx-auto mt-12 max-w-5xl">
      <div
        data-testid="commission-scale"
        className="rounded-[2rem] border border-[#D4AF37]/25 bg-[#0F0F12] p-8 sm:p-10"
      >
        <div className="flex flex-wrap items-baseline justify-between gap-3">
          <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-[#E5C158]">
            <span className="h-px w-8 shrink-0 bg-[#D4AF37]/60" />
            The 10% scale
          </p>
          <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-500">
            Win a job through the ads — I take 10%. Nothing else.
          </p>
        </div>

        <div className="mt-8">
          <div className="flex items-baseline justify-between gap-4">
            <label htmlFor="scale-slider" className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
              What an ad-won job pays you
            </label>
            <div className="flex flex-wrap justify-end gap-2">
              {PRESETS.map((v) => (
                <button
                  type="button"
                  key={v}
                  data-testid={`scale-preset-${v}`}
                  onClick={() => setPaid(v)}
                  className={`rounded-full border px-3.5 py-1.5 font-mono text-[9px] uppercase tracking-[0.15em] transition-[border-color,color,background-color] duration-300 ${
                    paid === v
                      ? "border-[#D4AF37] bg-[#D4AF37]/10 text-[#E5C158]"
                      : "border-white/10 text-neutral-400 hover:border-[#D4AF37]/40"
                  }`}
                >
                  {fmt(v)} job
                </button>
              ))}
            </div>
          </div>
          <input
            id="scale-slider"
            data-testid="scale-slider"
            type="range"
            min="1000"
            max="20000"
            step="500"
            value={paid}
            onChange={(e) => setPaid(Number(e.target.value))}
            className="mt-4 h-1.5 w-full cursor-pointer appearance-none rounded-full bg-white/10 accent-[#D4AF37]"
          />
          <div className="mt-2 flex justify-between font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-600">
            <span>$1k</span>
            <span>$20k</span>
          </div>
        </div>

        <div className="mt-8 grid gap-4 text-center sm:grid-cols-2">
          <div className="rounded-2xl border border-white/10 bg-[#0A0A0C] p-6">
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500">
              You get paid
            </p>
            <p data-testid="scale-paid" className="mt-2 font-mono text-3xl font-light tracking-tight text-white sm:text-4xl">
              {fmt(paid)}
            </p>
            <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">
              Jobs won through the ads
            </p>
          </div>
          <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#12100a] p-6">
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#E5C158]">
              My 10%
            </p>
            <p data-testid="scale-commission" className="mt-2 font-mono text-3xl font-light tracking-tight text-[#E5C158] sm:text-4xl">
              {fmt(paid * 0.1)}
            </p>
          </div>
        </div>
        <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
          Only jobs won through the ads count · one-time setup only ($550 — $450 bundled) · no monthly fees · ad spend paid directly to Meta
        </p>
      </div>
    </FadeUp>
  );
}